<template>
    <div class="bgf5">
        <div class="apply-invoice bgfff pt30 pl20 pr20">
            <div class="coupondalog" :style="{overflowY: 'scroll',height:'700px'}">
                <div class="coupondalog-t" style="font-size: 20px;font-weight: 500;color: #222222;">申请开票</div>
                <span @click.stop="cancle"
                      style="float: right;margin-top: -40px;margin-right: 20px;font-size: 20px;cursor: pointer;">x</span>
                <div class="coupon-tabs">
                    <div style="padding: 10px 40px;text-align: left">
                        <div class="price_title">发票类型</div>
                        <div style="margin-bottom: 50px">
                            <span :class="selected_canuse_receipt==1?'select_border':'unselect_border'"
                                  @click.stop="()=>{selected_canuse_receipt=1}">电子普通发票</span>
                            <span :class="selected_canuse_receipt==2?'select_border':'unselect_border'"
                                  style="margin-left: 20px" @click.stop="()=>{selected_canuse_receipt=2}">增值税专用发票</span>
                        </div>
                        <a-divider/>
                        <div class="price_title" style="padding-bottom: 0px;padding-top: 0px">发票信息</div>
                        <div v-if="selected_canuse_receipt!='2'">
                            <div>
                                <span class="rule">*</span>
                                <a-input
                                    style="width: 460px;height: 60px;border-radius: 2px;border: 1px solid #E5E5E5;margin: 20px 0px"
                                    v-model="form2.CorporateName"
                                    placeholder="请填写发票抬头"/>
                            </div>
                            <div style="padding-left: 15px">
                                <a-input
                                    style="width: 460px;height: 60px;border-radius: 2px;border: 1px solid #E5E5E5;margin: 20px 0px"
                                    v-model="form2.IdentificationNumber"
                                    placeholder="请填写纳税人识别号"/>
                            </div>
                            <p class="price_p">
                                平台默认开具电子普通发票，电子普通发票是税局认可的有效收付款凭证，其法律效力、基本用途及使用规定同纸质发票，如需纸质普通发票可自行下载打印，平台原则上不提供纸质普通发票。</p>
                            <p style="width: 90%;display: inline" class="price_p">如果您需要纸质普通发票，请选择纸质发票</p>
                            <span style="margin-left: 20%;font-size: 12px;color: #777777;"
                                  @click="isdisplay=!isdisplay">展开></span>
                            <div style="margin-top: 40px">
                                <span :style="{display:isdisplay?'none':''}"
                                      @click.stop="()=>{click=!click;selected_canuse_receipt=3}"
                                      :class="click&&selected_canuse_receipt==3?'click':'unclick'">纸质普通发票</span>
                            </div>

                            <!--                            <a-collapse v-model="activeKey">-->
                            <!--                                <a-collapse-panel key="1"  header="展开">-->
                            <!--                                   -->
                            <!--                                </a-collapse-panel>-->
                            <!--                            </a-collapse>-->
                            <div class="coupon-floor" style="margin-top: 150px;text-align: center;">
                                <!--                                <van-button @click="()=>{show_price = false;selected_canuse_receipt=0;priceType='暂不开票';cancle()}">暂不开票</van-button>-->
                                <van-button color="#0F6EEA" :disabled="!form2.CorporateName"
                                            @click.stop="()=>{toPrice();show_price = false;}"
                                >确定
                                </van-button>
                            </div>
                        </div>
                        <div v-if="selected_canuse_receipt=='2'" style="float: left;width: 60%">
                            <div>
                                <span class="rule">*</span>
                                <a-input
                                    style="width: 460px;height: 60px;border-radius: 2px;border: 1px solid #E5E5E5;margin: 20px 0px"
                                    v-model="form.CorporateName"
                                    placeholder="请填写发票抬头"/>
                            </div>
                            <div>
                                <span class="rule">*</span>
                                <a-input
                                    style="width: 460px;height: 60px;border-radius: 2px;border: 1px solid #E5E5E5;margin: 20px 0px"
                                    v-model="form.IdentificationNumber"
                                    placeholder="请填写纳税人识别号"/>
                            </div>
                            <div>
                                <span class="rule">*</span>
                                <a-input
                                    style="width: 460px;height: 60px;border-radius: 2px;border: 1px solid #E5E5E5;margin: 20px 0px"
                                    v-model="form.Address"
                                    placeholder="请填写门店地址"/>
                            </div>
                            <div>
                                <span class="rule">*</span>
                                <a-input
                                    style="width: 460px;height: 60px;border-radius: 2px;border: 1px solid #E5E5E5;margin: 20px 0px"
                                    v-model="form.Phone"
                                    placeholder="请填写联系人电话"/>
                            </div>
                            <div>
                                <span class="rule">*</span>
                                <a-input
                                    style="width: 460px;height: 60px;border-radius: 2px;border: 1px solid #E5E5E5;margin: 20px 0px"
                                    v-model="form.BankDeposit"
                                    placeholder="请填写开户银行"/>
                            </div>
                            <div>
                                <span class="rule">*</span>
                                <a-input
                                    style="width: 460px;height: 60px;border-radius: 2px;border: 1px solid #E5E5E5;margin: 20px 0px"
                                    v-model="form.BankAccount"
                                    placeholder="请填写银行账号"/>
                            </div>
                            <p class="price_p">提醒：</p>
                            <p class="price_p">请准确填写开具专票的相关信息，填写有误将影响为您开具发票， 您填写的信息务必与一般纳税人申请认定表一致。</p>
                            <div class="coupon-floor-more" style="text-align: center;">
                                <!--                                <van-button @click="()=>{show_price = false;selected_canuse_receipt=0;priceType='暂不开票';cancle()}">暂不开票</van-button>-->
                                <van-button color="#0F6EEA"
                                            :disabled="!(form.CorporateName&&form.IdentificationNumber&&form.Address&&form.Phone&&form.BankDeposit&&form.BankAccount&&conUploader.length>0)"
                                            @click.stop="()=>{toPrice();show_price = false;}"
                                >确定
                                </van-button>
                            </div>
                        </div>
                        <div v-if="selected_canuse_receipt=='2'" style="float: left;width: 40%">
                            <span>上传开票资料</span>
                            <div style="width: 100%">
                                <van-grid :border="false" :column-num="4">
                                    <van-grid-item v-for="(item,index) in conUploader" :key="index">
                                        <iFile class="i_radius fx justify-content-center"
                                               style="width: 100%;height: 200px"
                                               :bg="_getPic(item.ImageUrl,true)" readonly>
                                            <van-icon name="clear" size="20px"
                                                      style="position: absolute;top: -10px;right: -10px;"
                                                      class="c999 cpointer" @click.stop="delImage(index)"/>
                                        </iFile>
                                    </van-grid-item>
                                    <van-grid-item v-if="conUploader.length==0">
                                        <iFile class="i_radius hidden fx justify-content-center cpointer"
                                               style="width: 100%;height: 100%"
                                               @change="onFile">
                                            <van-icon :name="require('../../assets/mine/xiangji.png')" size="36px"
                                                      color="#999"/>
                                        </iFile>
                                    </van-grid-item>
                                </van-grid>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import {BaseMixin} from "../../mixins/BaseMixin.js";
    import iFile from "@/components/uploader.vue";

    export default {
        name: "ApplyInvoiceFormCopy",
        mixins: [BaseMixin],
        components: {iFile},
        props: {
            isdialog: {type: Boolean, default: false},
            isReadOnly: {type: Boolean, default: false}
        },
        data() {
            return {
                PriceModel: 1,
                isdisplay: true,
                click: false,
                activeKey: [],
                selected_canuse_receipt: '',
                form: {
                    IdentificationNumber: "",
                    BankDeposit: "",
                    BankAccount: "",
                    CorporateName: "",
                    Address: "",
                    Phone: ""
                },
                form2: {
                    CorporateName: "",
                    IdentificationNumber: ""
                },
                show_price: false,
                priceType: '',
                OrderInvoiceType: '',
                conUploader: [],
                Id: '',
            };
        },
        async mounted() {
            this.loadData();

        },
        methods: {
            goApplyInvoice(id) {
                this.setApplyInvoiceId(id)
            },
            async setApplyInvoiceId(Id) {
                this.Id = Id;
                // 获取订单编号
                const res = await this.getAction(
                    "/api_aftersale/OrderInvoice/GetOrderInvoice", {orderId: Id}
                );
                if (res.IsSuccess && res.Data.length > 0) {
                    this.selected_canuse_receipt = res.Data[0].OrderInvoiceType === 1 ? 1 : 2;
                }
            },
            delImage(index) {
                this.conUploader.splice(index, 1);
            },
            cancle() {
                this.$emit("cancel");
            },
            onFile(file) {
                this.SignImage = file;
                let img = {
                    ImageUrl: this.SignImage
                };
                this.conUploader.push(img);
            },
            async toPrice() {
                let params = '';
                if (this.selected_canuse_receipt != 2) {
                    params = {
                        Id: this.Id,
                        Name: this.form2['CorporateName'],
                        IdentificationNo: this.form2['IdentificationNumber'],
                    };
                } else {
                    params = {
                        Id: this.Id,
                        Name: this.form['CorporateName'],
                        IdentificationNo: this.form['IdentificationNumber'],
                        BankOfDeposit: this.form['BankDeposit'],
                        BankAccount: this.form['BankAccount'],
                        Address: this.form['Address'],
                        Phone: this.form['Phone'],
                        IdentificationPicUrl: this.conUploader[0]
                    };
                }
                this.$hys.openLoading();
                const res = await this.putAction(
                    "api_customer/InvoiceInformation/AddOrUpdate",
                    params
                );
                this.$hys.clearLoading();
                if (res.IsSuccess) {
                    this.priceType = this.selected_canuse_receipt == 1 ? '电子普通发票' : this.selected_canuse_receipt == 2 ? '增值税专用发票' : this.selected_canuse_receipt == 3 ? '纸质普通发票' : '暂不开票'
                    this.$toast.success("提交成功");
                    this.cancle();
                    location.reload();
                    setTimeout(() => {
                        this.conUploader = [];
                        this.btn = false;
                    }, 1500);
                } else {
                    this.$toast({position: "bottom", message: res.Msg});
                    this.btn = false;
                }
            },
            // 获取客户信息
            async getCustomerInfo() {
                const res = await this.getAction(
                    "/api_customers/Customer/GetBusinessLincenseAttr"
                );
                if (res.IsSuccess && res.Data) {
                    if (!this.form["IdentificationNumber"] && res.Data.length)
                        this.form["IdentificationNumber"] =
                            res.Data[0].CustomerAttrDtos[0].AttrValue || "";
                    this.form2["IdentificationNumber"] =
                        res.Data[0].CustomerAttrDtos[0].AttrValue || "";
                }
            },
            async loadData() {
                this.$hys.openLoading();
                const res = await this.getAction(
                    "/api_customer/InvoiceInformation/Detail"
                );
                // console.log('获取发票信息', res)

                if (res.IsSuccess && res.Data) {
                    this.Id = res.Data.Id
                    this.form["IdentificationNumber"] = res.Data.IdentificationNo || "";
                    this.form["BankDeposit"] = res.Data.BankOfDeposit || "";
                    this.form["BankAccount"] = res.Data.BankAccount || "";
                    this.form["CorporateName"] =
                        res.Data.Name || this.auth.getCustomerName();
                    this.form["Address"] =
                        res.Data.Address || this.auth.getCustomerInfo()["Address"];

                    this.form["Phone"] =
                        res.Data.Phone || this.auth.getCustomerInfo()["Phone"];

                    this.form2["CorporateName"] =
                        res.Data.Name || this.auth.getCustomerName();
                    this.form2["IdentificationNumber"] = res.Data.IdentificationNo || "";
                    this.getCustomerInfo();
                    if (res.Data.IdentificationPicUrl) {
                        this.conUploader.push({ImageUrl: res.Data.IdentificationPicUrl});
                    }
                } else {
                    this.$toast({position: "bottom", message: res.Msg});
                }

                const resTo = await this.getAction(
                    "/api_aftersale/OrderInvoice/GetOrderInvoiceListByCustomerId"
                );
                if (resTo.IsSuccess) {
                    if (resTo.Data == null) {
                        this.priceType = '请选择';
                    } else {
                        this.priceType = resTo.Data.OrderInvoiceTypee_txt;
                        this.selected_canuse_receipt = resTo.Data.OrderInvoiceType;
                    }

                } else {
                    this.$toast({position: "bottom", message: res.Msg});
                }
                this.$hys.clearLoading();
            }
        }
    };
</script>
<style lang="less" scoped>
    /*.apply-invoice {*/
    /*    border-radius: 2px;*/
    /*    border: 1px solid rgba(232, 232, 232, 1);*/
    /*    width: 100%;*/
    /*    box-sizing: border-box;*/
    /*    padding-bottom: 50px;*/
    /*    overflow-y: scroll;*/
    /*    min-height: 668px;*/

    /*    /deep/ .van-tabs {*/
    /*        /deep/ .van-tabs__wrap {*/
    /*            border-bottom: 2px solid #3183ec;*/
    /*        }*/
    /*    }*/

    /*    /deep/ .van-tab {*/
    /*        justify-content: flex-start;*/
    /*        width: 226px;*/
    /*        flex: none;*/
    /*        align-items: flex-start;*/

    /*        &::after {*/
    /*            width: 169px !important;*/
    /*        }*/
    /*    }*/

    /*    /deep/ .van-field.input-bo {*/
    /*        padding: 0;*/

    /*        .van-field__label {*/
    /*            position: absolute;*/
    /*            top: 10px;*/
    /*            left: 15px;*/
    /*            line-height: 20px;*/
    /*        }*/

    /*        input {*/
    /*            border-radius: 2px;*/
    /*            border: 1px solid rgba(229, 229, 229, 1);*/
    /*            padding-top: 30px;*/
    /*            padding-bottom: 10px;*/
    /*            padding-left: 12px;*/
    /*            padding-right: 12px;*/

    /*            &:focus {*/
    /*                border-radius: 2px;*/
    /*                border: 3px solid rgba(15, 110, 233, 1);*/
    /*                padding-top: 26px;*/
    /*                padding-bottom: 10px;*/
    /*                padding-left: 12px;*/
    /*                padding-right: 12px;*/
    /*            }*/
    /*        }*/
    /*    }*/

    /*    .pl86 {*/
    /*        padding-left: 86px;*/

    /*        ul {*/
    /*            padding-left: 15px;*/

    /*            > li {*/
    /*                color: #777777;*/
    /*                font-size: 12px;*/
    /*                text-align: left;*/
    /*                margin-bottom: 10px;*/
    /*                list-style: disc;*/
    /*            }*/
    /*        }*/

    /*        .more {*/
    /*            position: relative;*/

    /*            /deep/ .van-icon {*/
    /*                position: absolute;*/
    /*                top: 50%;*/
    /*                transform: translateY(-50%);*/
    /*            }*/
    /*        }*/
    /*    }*/

    /*    .submitBtn {*/
    /*        width: 164px;*/
    /*        height: 50px;*/
    /*    }*/

    /*    .pt06 {*/
    /*        padding-top: 6px;*/
    /*    }*/

    /*    /deep/ .van-grid-item__content {*/
    /*        padding: 0;*/
    /*        width: 100px;*/
    /*        height: 100px;*/
    /*    }*/

    /*    .bgmoren {*/
    /*        width: 100px;*/
    /*        height: 100px;*/
    /*        border-radius: 2px;*/
    /*        border: 1px solid rgba(229, 229, 229, 1);*/
    /*    }*/

    /*    .scrollWrapper {*/
    /*        max-height: 400px;*/
    /*        overflow-y: auto;*/

    /*        &::-webkit-scrollbar {*/
    /*            !*滚动条整体样式*!*/
    /*            width: 10px;*/
    /*            !*高宽分别对应横竖滚动条的尺寸*!*/
    /*            height: 1px;*/
    /*        }*/

    /*        &::-webkit-scrollbar-thumb {*/
    /*            !*滚动条里面小方块*!*/
    /*            border-radius: 10px;*/
    /*            box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);*/
    /*            background: #e8e8e8;*/
    /*        }*/

    /*        &::-webkit-scrollbar-track {*/
    /*            !*滚动条里面轨道*!*/
    /*            box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);*/
    /*            border-radius: 10px;*/
    /*            background: #f5f5f5;*/
    /*        }*/
    /*    }*/
    /*}*/

    /*.c999i {*/
    /*    color: #999 !important;*/
    /*}*/
    /*/deep/.ant-collapse-content-active{*/
    /*    height: 100px;*/
    /*    padding-top: 20px;*/
    /*}*/
    .coupon-floor {
        height: 100px;
        width: 100%;
        display: flex;
        justify-content: center;
        position: absolute;
        top: 520px;
        left: 0;


        button {
            width: 140px;
            height: 50px;
            font-size: 16px;
            color: #999999;

            &:first-child {
                margin-right: 30px;
            }
        }
    }

    .coupon-floor-more {
        height: 100px;
        width: 100%;
        /*display: flex;*/
        justify-content: center;
        /*position: absolute;*/
        /*top: 10%;*/
        margin-left: 30%;

        left: 0;


        button {
            width: 140px;
            height: 50px;
            font-size: 16px;
            color: #999999;

            &:first-child {
                margin-right: 30px;
            }
        }
    }

    .price_title {
        font-family: '';
        padding: 45px 0px;
        font-size: 16px;
        font-weight: 500;
        color: #222222;
        line-height: 22px;
    }

    .rule {
        color: red;
        margin-right: 10px;
    }

    .price_p {

        font-size: 12px;
        font-weight: 400;
        color: #777777;
        line-height: 18px;
    }

    .select_border {
        padding: 15px 20px;
        color: #FF3939;
        background: #FFF3F3;
        border: 1px solid #FF3939 !important;
    }

    .unselect_border {
        padding: 15px 20px;
        border: 1px solid rgb(229, 229, 229);
    }

    .unclick {
        margin-top: 10px;
        padding: 15px 20px;
        border: 1px solid rgb(229, 229, 229);
        color: black;
        background: none;
    }

    .click {
        margin-top: 10px;
        padding: 15px 20px;
        border: 1px solid #ff3939;
        color: #ff3939;
        background: #FFF3F3;
    }

</style>
